import { ControllerExceptionCodes } from 'utils/controllerException';

/**
 * The submit action of the question card (phase 32): the drafter's typed questions answered in place. The generic
 * renderer sends it, the drafting process intercepts it and runs the round that replays the captured propose call.
 */
export const questionsCardAction = 'automationQuestions';

/** The refusals of a SkillControl turn that the panel answers with a card (SkillControlAccessCard). */
const skillControlRefusals: string[] = [
  ControllerExceptionCodes.Code_McpConnection_NotConnected,
  ControllerExceptionCodes.Code_McpConnection_UserNotAuthorized,
  ControllerExceptionCodes.Code_McpConnection_NeedsReauthorization,
  ControllerExceptionCodes.Code_McpConnection_SkillOwnerRequired,
  ControllerExceptionCodes.Code_McpConnection_NoSkillControlAccount,
];

export const isSkillControlRefusal = (code: string | undefined): boolean => {
  return code !== undefined && skillControlRefusals.includes(code);
};
